export default "__VITE_ASSET__Bfw4wSkL__"